
import { Vue, Component, Prop } from "vue-property-decorator";
import First from "./First.vue";
import ThankYou from "./ThankYou.vue";
import { SUBSCRIPTION_FORM_STEPS } from "../service";

@Component({
  components: {
    First,
    ThankYou
  }
})
export default class extends Vue {
  @Prop(String) readonly json!: string;
  configFirst = JSON.parse(this.json);
  configThankYou = this.configFirst.labels.thankYou;

  STEPS = SUBSCRIPTION_FORM_STEPS;
  currentStep = SUBSCRIPTION_FORM_STEPS.FIRST_STEP;

  async onSuccess() {
    this.currentStep = this.STEPS.THANK_YOU_STEP;
  }
}
